import React, { useEffect, useState } from "react";
import JobTableSection from "../../Components/JobBoardItems/JobsList/JobsList";
import ViewJobModal from "../../Components/JobBoardItems/ViewJobModal/ViewJobModal";
import "./Jobs.scss";
import apiClient from "../../../../../Config/apiClient";
import { hasPermission } from "../../Services/permission";
import { jwtDecode } from "jwt-decode";

const jobsBaseUrl = process.env.REACT_APP_TC_JOBS_BASE_PATH;

const JOB_SECTION = "jobs";
const JOB_EDIT_KEY = ["jobs_edit"];

const JobsPage = () => {
  const [startingJobs, setStartingJobs] = useState([]);
  const [progressJobs, setProgressJobs] = useState([]);
  const [allJobs, setAllJobs] = useState([]);
  const [activeTab, setActiveTab] = useState("all");
  const [loading, setLoading] = useState(false);
  const [companyId, setCompanyId] = useState(null);
  const [userRole, setUserRole] = useState(null);
  const [userId, setUserId] = useState(null);

  const [jobsPerPage, setJobsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [searchTerm, setSearchTerm] = useState("");

  const [filtersData, setFiltersData] = useState({
    starting: {
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: "",
    },
    progress: {
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: "",
    },
    all: {
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: "",
    },
  });

  const [jobData, setJobData] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [refresh, setRefresh] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      const decoded = jwtDecode(token);
      setCompanyId(decoded.company_id);
    }
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("accessToken");
    if (token) {
      const decoded = jwtDecode(token);
      setUserRole(decoded.role);
      setUserId(decoded.user_id);
    }
  }, []);

  const canEditJobs = hasPermission({ section: JOB_SECTION, keys: JOB_EDIT_KEY, });

  useEffect(() => {
    const fetchJobs = async () => {
      try {
        setLoading(true);

        const token = localStorage.getItem("accessToken");
        const decoded = jwtDecode(token);
        const companyId = decoded.company_id;

        const response = await apiClient.get(`${jobsBaseUrl}/all`, {
          params: {
            tc_company_id: companyId,
            ...filtersData[activeTab],
          },
        });

        const jobs = response.data.data || [];

        setStartingJobs(jobs.filter(job => job.job_status === "starting"));
        setProgressJobs(jobs.filter(job => job.job_status === "progress"));
        setAllJobs(jobs);

      } catch (err) {
        console.error("Error fetching jobs:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, [refresh, activeTab, filtersData]);


  const getJobsForActiveTab = () => {
    switch (activeTab) {
      case "starting":
        return Array.isArray(startingJobs) ? startingJobs : [];
      case "progress":
        return Array.isArray(progressJobs) ? progressJobs : [];
      case "all":
        return Array.isArray(allJobs) ? allJobs : [];
      default:
        return [];
    }
  };

  const getJobsForRole = (jobs) => {
    if (userRole === "Truck Driver" && userId) {
      return jobs.filter(job => job.assigned_driver_id === userId);
    }
    return jobs;
  };

  const jobsForDisplay = getJobsForRole(getJobsForActiveTab());

  const updateJobLocally = (updatedJob) => {
    setStartingJobs(prev => prev.map(j => j.id === updatedJob.id ? updatedJob : j));
    setProgressJobs(prev => prev.map(j => j.id === updatedJob.id ? updatedJob : j));
    setAllJobs(prev => prev.map(j => j.id === updatedJob.id ? updatedJob : j));
  };

  const totalJobs = getJobsForActiveTab().filter((job) =>
    (job.job_name && job.job_name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (job.job_description && job.job_description.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (job.job_type && job.job_type.toLowerCase().includes(searchTerm.toLowerCase()))
  ).length;
  const startIndex = (currentPage - 1) * jobsPerPage;

  const handleFilterChange = async (newFilters) => {
    setFiltersData(prev => ({
      ...prev,
      [activeTab]: newFilters,
    }));
    setCurrentPage(1);
    setRefresh(prev => !prev);
  };


  const resetFilters = () => {
    const defaultFilters = {
      job_type: "",
      truck_type: "",
      start_date_from: "",
      start_date_to: "",
      end_date_from: "",
      end_date_to: "",
      posted_date_from: "",
      posted_date_to: "",
    };

    setFiltersData(prev => ({
      ...prev,
      [activeTab]: defaultFilters,
    }));

    setCurrentPage(1);
    setRefresh(prev => !prev);
  };

  const handleStatusChange = (newStatus) => {
    setRefresh(prev => !prev);
  };

  return (
    <main className="full-wraper">
      <div className="main-wraper">
        <div className="container-fluid">
          <div className="main-inner">

            <JobTableSection
              jobs={jobsForDisplay}
              jobsPerPage={jobsPerPage}
              currentPage={currentPage}
              onPageChange={setCurrentPage}
              setJobsPerPage={setJobsPerPage}
              totalJobs={totalJobs}
              startIndex={startIndex}
              onSearchChange={setSearchTerm}
              searchTerm={searchTerm}
              setJobData={setJobData}
              setShowModal={setShowModal}
              filters={filtersData[activeTab]}
              onFilterChange={handleFilterChange}
              resetFilters={resetFilters}
              loading={loading}
              setRefresh={setRefresh}
              canEditJobs={canEditJobs}
              updateJobLocally={updateJobLocally}
            />
          </div>
        </div>
      </div>

      <ViewJobModal jobId={jobData?.id} refresh={() => setRefresh(prev => !prev)} onStatusChange={handleStatusChange} />
    </main>
  );
};

export default JobsPage;